/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ASRProviderLanguageRead } from '../models/ASRProviderLanguageRead';
import type { ASRProviderLanguageWriteSerializerWithRepr } from '../models/ASRProviderLanguageWriteSerializerWithRepr';
import type { ASRProviderRead } from '../models/ASRProviderRead';
import type { ASRProviderWriteSerializerWithRepr } from '../models/ASRProviderWriteSerializerWithRepr';
import type { PaginatedASRProviderLanguageListList } from '../models/PaginatedASRProviderLanguageListList';
import type { PaginatedASRProviderLanguageWriteSerializerWithReprList } from '../models/PaginatedASRProviderLanguageWriteSerializerWithReprList';
import type { PaginatedASRProviderReadList } from '../models/PaginatedASRProviderReadList';
import type { PaginatedASRProviderWriteSerializerWithReprList } from '../models/PaginatedASRProviderWriteSerializerWithReprList';
import type { PatchedASRProviderLanguageWriteSerializerWithRepr } from '../models/PatchedASRProviderLanguageWriteSerializerWithRepr';
import type { PatchedASRProviderWriteSerializerWithRepr } from '../models/PatchedASRProviderWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AsrService {
    /**
     * @returns PaginatedASRProviderReadList
     * @throws ApiError
     */
    public static asrList({
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderReadList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/asr/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns ASRProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrCreate({
        requestBody,
    }: {
        requestBody: ASRProviderWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/asr/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedASRProviderWriteSerializerWithReprList
     * @throws ApiError
     */
    public static asrProviderBulkUpdate({
        requestBody,
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<ASRProviderWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/asr/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedASRProviderWriteSerializerWithReprList
     * @throws ApiError
     */
    public static asrProviderBulkPartialUpdate({
        requestBody,
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<ASRProviderWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/asr/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static asrProviderBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/asr/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ASRProviderRead
     * @throws ApiError
     */
    public static asrRetrieve({
        id,
        excludeFields,
        fields,
        languages,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this asr provider.
         */
        id: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<ASRProviderRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/asr/{id}/',
            path: {
                'id': id,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns ASRProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asr provider.
         */
        id: number,
        requestBody: ASRProviderWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/asr/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ASRProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asr provider.
         */
        id: number,
        requestBody?: PatchedASRProviderWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/asr/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static asrDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this asr provider.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/asr/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PaginatedASRProviderLanguageListList
     * @throws ApiError
     */
    public static asrModelsList({
        providerPk,
        excludeFields,
        fields,
        language,
        limit,
        model,
        offset,
        ordering,
        provider,
        readDepth,
        search,
    }: {
        providerPk: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        model?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderLanguageListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/asr/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'model': model,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns ASRProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrModelsCreate({
        providerPk,
        requestBody,
    }: {
        providerPk: number,
        requestBody: ASRProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/asr/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedASRProviderLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static asrProviderLanguageBulkUpdate({
        providerPk,
        requestBody,
        excludeFields,
        fields,
        language,
        limit,
        model,
        offset,
        ordering,
        provider,
        readDepth,
        search,
    }: {
        providerPk: number,
        requestBody: Array<ASRProviderLanguageWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        model?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/asr/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'model': model,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedASRProviderLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static asrProviderLanguageBulkPartialUpdate({
        providerPk,
        requestBody,
        excludeFields,
        fields,
        language,
        limit,
        model,
        offset,
        ordering,
        provider,
        readDepth,
        search,
    }: {
        providerPk: number,
        requestBody: Array<ASRProviderLanguageWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        model?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedASRProviderLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/asr/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'model': model,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static asrProviderLanguageBulkDestroy({
        providerPk,
        id,
    }: {
        providerPk: number,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/asr/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ASRProviderLanguageRead
     * @throws ApiError
     */
    public static asrModelsRetrieve({
        id,
        providerPk,
        excludeFields,
        fields,
        language,
        model,
        provider,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this asr provider language.
         */
        id: number,
        providerPk: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        model?: Array<string>,
        provider?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<ASRProviderLanguageRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/asr/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'model': model,
                'provider': provider,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns ASRProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrModelsUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asr provider language.
         */
        id: number,
        providerPk: number,
        requestBody: ASRProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/asr/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ASRProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static asrModelsPartialUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this asr provider language.
         */
        id: number,
        providerPk: number,
        requestBody?: PatchedASRProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<ASRProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/asr/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static asrModelsDestroy({
        id,
        providerPk,
    }: {
        /**
         * A unique integer value identifying this asr provider language.
         */
        id: number,
        providerPk: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/asr/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
        });
    }
}
